import _descriptors from "../internals/descriptors";
import _regexpUnsupportedDotAll from "../internals/regexp-unsupported-dot-all";
import _classofRaw from "../internals/classof-raw";
import _defineBuiltInAccessor from "../internals/define-built-in-accessor";
import _internalState from "../internals/internal-state";
var DESCRIPTORS = _descriptors;
var UNSUPPORTED_DOT_ALL = _regexpUnsupportedDotAll;
var classof = _classofRaw;
var defineBuiltInAccessor = _defineBuiltInAccessor;
var getInternalState = _internalState.get;
var RegExpPrototype = RegExp.prototype;
var $TypeError = TypeError;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
  defineBuiltInAccessor(RegExpPrototype, "dotAll", {
    configurable: true,
    get: function dotAll() {
      if (this === RegExpPrototype) return;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === "RegExp") {
        return !!getInternalState(this).dotAll;
      }
      throw new $TypeError("Incompatible receiver, RegExp required");
    }
  });
}
export default {};